import {
  listPublicPlansApiV1PublicPlansGet,
  validateCouponApiV1PublicCouponsValidateGet,
} from "@/backend-sdk/client/sdk.gen";
import type {
  CouponValidationResponse,
  PublicPlanResponse,
} from "@/backend-sdk/client/types.gen";

export type Plan = PublicPlanResponse;
export type CouponValidation = CouponValidationResponse;

/** Só os planos de lojista são oferecidos para assinar pelo painel. */
export const CATEGORIA_DO_CADASTRO = "lojista";

/**
 * Os planos que se assinam pelo painel, do mais barato ao mais caro.
 *
 * Mora aqui, e não em cada tela, porque são duas as vitrines — `/register/plans` e a aba
 * Assinatura de quem entrou sem plano — e elas precisam oferecer a mesma coisa.
 */
export const planosDoCadastro = (plans: Plan[]): Plan[] =>
  plans
    .filter((p) => p.category === CATEGORIA_DO_CADASTRO)
    .sort((a, b) => a.price_monthly - b.price_monthly);

class PlanService {
  async listPublicPlans(): Promise<Plan[]> {
    const { data: res } = await listPublicPlansApiV1PublicPlansGet({
      headers: { "x-ignore-global-filters": "1" },
      throwOnError: true,
    });
    return res.data;
  }

  async validateCoupon(
    code: string,
    email?: string,
    planId?: string,
  ): Promise<CouponValidation> {
    const { data } = await validateCouponApiV1PublicCouponsValidateGet({
      headers: { "x-ignore-global-filters": "1" },
      query: { code, email, plan_id: planId },
      throwOnError: true,
    });
    return data;
  }
}

export default new PlanService();
